export function mergeTranslations(base, overrides) {
    const result = { ...base };

    for (const key in overrides) {
        if (
            overrides[key] &&
            typeof overrides[key] === 'object' &&
            !Array.isArray(overrides[key])
        ) {
            result[key] = mergeTranslations(result[key] || {}, overrides[key]);
        } else {
            result[key] = overrides[key];
        }
    }

    return result;
}
